<script setup lang="ts">
import { computed } from "vue";
import { calculatePageCount } from "@/services/functions";

const props = defineProps<{
  itemsPerPage: number
  currentPage: number
  allElementsCount: number
}>();

const itemStartIndex = computed(() => {
  return (props.currentPage - 1) * props.itemsPerPage + 1
})

const itemEndIndex = computed(() => {
  return isLastPage.value ? props.allElementsCount : props.currentPage * props.itemsPerPage
})

const isLastPage = computed(() => {
  return props.currentPage === calculatePageCount(props.allElementsCount, props.itemsPerPage)
})
</script>
<template>
  <div class="count-items">
    <template v-if="allElementsCount > 0" >
      <span>
        {{ itemStartIndex }} - {{itemEndIndex}} / {{allElementsCount}}
      </span>
    </template>
  </div>
</template>
<style scoped>
.count-items span {
  font-size: 14px;
}
</style>
